import type {IConfigLoader} from "header-bidding-client-base/modules/config/domain/iConfigLoader";
import type {ILogger} from "header-bidding-client-base/modules/logger/domain/iLogger";
import {ConsoleLogger} from "header-bidding-client-base/modules/logger/infrastructure/consoleLogger";
import {GptHeaderBiddingAdapter} from "header-bidding-client-base/modules/header-bidding/infrastructure/gpt/gptHeaderBiddingAdapter";

export const initGptHeaderBidding = ( configLoader: IConfigLoader, prebidJSBiddersLoaderClass?: any, initiatedCallback?: () => void ) => {
    configLoader.loadConfig().then(({globalConfig, headerBiddingConfig}) => {

        try {
            // Define dependencies
            const logger: ILogger = new ConsoleLogger(globalConfig);
            logger.log("Global config loaded", globalConfig);
            logger.log("Header Bidding config loaded", headerBiddingConfig);

            // Initialize script
            const headerBiddingGpt = new GptHeaderBiddingAdapter(headerBiddingConfig, globalConfig, logger, prebidJSBiddersLoaderClass ? new prebidJSBiddersLoaderClass(logger) : undefined);
            headerBiddingGpt.init(initiatedCallback).then(() => {
                console.log("Header Bidding script loaded");
            });

        } catch (error) {
            console.error("Error initializing Header Bidding. Firing failsafe event", error);
            fireFailedEvent();
        }

    });

    function fireFailedEvent() {
        var event = new CustomEvent('alpred:hb:load_failed', {
            bubbles: true
        });
        document.dispatchEvent(event);
    }
}
